import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit'
import { ParticipantExportType } from 'pages/Participants/model/participant'

export interface ProgramsState {
  recentAddedSessionId: string
}

const initialState: ProgramsState = {
  recentAddedSessionId: '',
}

const programs = createSlice({
  name: 'programs',
  initialState,
  reducers: {
    setRecentAddedSessionId(state, { payload }: PayloadAction<string | undefined>) {
      state.recentAddedSessionId = payload || ''
    },
  },
})

export type ExportAllUserType = ParticipantExportType & {
  role_id: string
  role_name: string
}

export const { setRecentAddedSessionId } = programs.actions
export const exportProgram = createAction<{ id: string; name: string }>('programs/exportProgram')
export const exportAllProgram = createAction('programs/exportAllProgram')
export const exportEvent = createAction<{ id: string; name: string }>('programs/exportEvent')

export default programs.reducer
